<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer012">
<h1 class="Prelim-head" id="_idParaDest-1"><a id="_idTextAnchor000"></a>About the Author</h1>
<p class="Prelim-text">Rita is married with adult sons and grandchildren. As well as writing for children, she is an avid reader. Her interests include nature, gardening, crafts and walking her dog. She worked in two schools for around 25 years as a dinner lady. Out of hours, she is a club worker, classroom assistant, special needs teaching assistant and breakfast club leader.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781528954297_EPUB.vue?1b9ab6a0